<template>
  <div class="canPublish-platform-wrap">
    <el-popover placement="right-start" :disabled="canPublishPlatform.length < 4" trigger="hover" width="200">
      <el-row>
        <el-avatar
          v-for="item in canPublishPlatform"
          :key="item"
          class="mar-r-10"
          shape="square"
          size="small"
          :src="PLATFORM_ICONS_MAP[item]"
        ></el-avatar>
      </el-row>
      <el-row class="canPublish-platfor-row" slot="reference">
        <span style="color: #aaa;">可铺货平台：</span>
        <template v-if="canPublishPlatform.length > 3">
          <el-avatar
            v-for="item in canPublishPlatform.slice(0, 3)"
            :key="item"
            class="mar-r-10"
            shape="square"
            size="small"
            :src="PLATFORM_ICONS_MAP[item]"
          ></el-avatar>
          <div style="color: #aaa;"><i class="el-icon-more" /></div>
        </template>
        <template
          v-if="
            canPublishPlatform.length <= 3 && canPublishPlatform.length != 0
          "
        >
          <el-avatar
            v-for="item in canPublishPlatform"
            :key="item"
            class="mar-r-10"
            shape="square"
            size="small"
            :src="PLATFORM_ICONS_MAP[item]"
          ></el-avatar>
        </template>
        <template v-if="canPublishPlatform.length == 0"> 暂无 </template>
      </el-row>
    </el-popover>
  </div>
</template>

<script>
import { PLATFORM_ICONS_MAP } from "@/dictionary/platforms.js";
export default {
  props: {
    canPublishPlatform: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      PLATFORM_ICONS_MAP,
    };
  },
};
</script>

<style lang="scss" scoped>
.el-avatar--small {
  width: 20px;
  height: 20px;
  line-height: 20px;
  margin-right: 5px;
}
.canPublish-platfor-row {
    display: flex;
    align-items: center;
}
</style>